var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentImport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 10.5V7.49998C18.0006 7.40128 17.9817 7.30343 17.9443 7.21205C17.907 7.12067 17.852 7.03756 17.7825 6.96748L12.5325 1.71748C12.4624 1.64797 12.3793 1.59298 12.2879 1.55565C12.1966 1.51833 12.0987 1.49941 12 1.49998H4.5C4.10218 1.49998 3.72064 1.65802 3.43934 1.93932C3.15804 2.22063 3 2.60216 3 2.99998V21C3 21.3978 3.15804 21.7793 3.43934 22.0606C3.72064 22.3419 4.10218 22.5 4.5 22.5H16.5C16.8978 22.5 17.2794 22.3419 17.5607 22.0606C17.842 21.7793 18 21.3978 18 21V19.5H16.5V21H4.5V2.99998H10.5V7.49998C10.5 7.89781 10.658 8.27934 10.9393 8.56064C11.2206 8.84195 11.6022 8.99998 12 8.99998H16.5V10.5H18ZM12 7.49998V3.30748L16.1925 7.49998H12Z",
    fill: "#265EA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 14.25H11.1225L13.0575 12.3075L12 11.25L8.25 15L12 18.75L13.0575 17.6925L11.1225 15.75H21V14.25Z",
    fill: "#67C2E7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentImport);
export default __webpack_public_path__ + "static/media/DocumentImport.2b90aed1c423568b4d38aa84d2ced882.svg";
export { ForwardRef as ReactComponent };